import SSharedList from '@/services/shared/list.service'

export default {
  methods: {
    /**
     * Fetches roles from the API and populates the target object's options
     * @param {Object} target - The target object containing options and fetching states
     * @returns {Promise} - Promise that resolves when roles are fetched
     */
    async getRoles (target) {
      target.fetching.roles = true

      return SSharedList.getRoles()
        .then(({ data }) => {
          target.options.roles = data.data || []
        })
        .catch(() => {
          target.options.roles = []
        })
        .finally(() => {
          target.fetching.roles = false
        })
    }
  }
}
